/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloError } from "@apollo/client";
import { SVGIcon } from "@nordcloud/gnui";
import { FiltersProp } from "~/models/estateRecordRow";
import { AccountStatus } from "~/tools";

export type ApplicationOption = {
  id: string;
  nid: string;
  name: string;
  environments: EnvironmentOption[];
};

export type CloudWasteOption = {
  category: string;
  categoryName: string;
  policies: PolicyOption[];
  isInextensible?: boolean;
};

export type PolicyOption = {
  id: string;
  name: string;
  isHidden?: boolean;
};

export type EnvironmentOption = {
  id: string;
  nid: string;
  name: string;
  displayName?: string;
};

export type FiltersOptions = {
  accountsOptions: {
    value: string;
    label: string;
    status: AccountStatus;
  }[];
  regionOptions: {
    value: string;
    label: string;
  }[];
  resourceTypes: {
    value: string;
    label: string;
  }[];
  categories: {
    value: string;
    label: string;
  }[];
  services: {
    value: string;
    label: string;
  }[];
  cloudWastePolicies: {
    value: string | null | undefined;
    label: string | null | undefined;
  }[];
  cloudWastePoliciesCategorised: {
    category: string;
    categoryName: string;
    policies: {
      id: string;
      name: string;
    }[];
  }[];
  externalIntegrations: {
    value: string;
    label: string;
  }[];
  error: ApolloError | undefined;
  loadingExternalIntegrations: boolean;
  loadingCategories: boolean;
  loadingCloudWaste: boolean;
  loadingResourceTypes: boolean;
  loadingAccounts: boolean;
  loadingCloudWastePoliciesCategorised: boolean;
  isLoadingServices: boolean;
};

export type PodStatus = {
  status: string;
  icon: React.ComponentProps<typeof SVGIcon>["name"];
  tooltipStatus?: "danger" | "notification" | "success" | "warning";
};

export type FilterProps = {
  filters: FiltersProp;
  setFilters: (input: FiltersProp) => void;
};

export enum BillingPeriod {
  Current = "CURRENT",
  Previous = "PREVIOUS",
}

export const CARBON_FOOTPRINT_SUGGESTION = {
  nid: "CARBON",
  name: "Carbon Footprint Saving Suggestions",
};
